function Picture() {
    return(
        <div>
            <img src="web-style/headshot.jpg" alt="Headshot" className="headshot"/>
        </div>
    ); 
}

export default Picture; 